<template>
    <section class="splide edc-footer__splide" id="footer-splide">
        <div class="splide__track">
            <ul class="splide__list">
                <li class="splide__slide"><img src="../assets/logos/logo-blazing.png" /></li>
                <li class="splide__slide"><img src="../assets/logos/logo-certika.png" /></li>
                <li class="splide__slide"><img src="../assets/logos/logo-cesar.png" /></li>
                <li class="splide__slide"><img src="../assets/logos/logo-cesar-2.png" /></li>
                <li class="splide__slide"><img src="../assets/logos/logo-ciencias.png" /></li>
                <li class="splide__slide"><img src="../assets/logos/logo-min.png" /></li>
                <li class="splide__slide"><img src="../assets/logos/logo-ra.png" /></li>
                <li class="splide__slide"><img src="../assets/logos/logo-upc.png" /></li>
            </ul>
        </div>
    </section>
    <footer class="edc-footer">
        <div class="content">
            <div class="navegation">
                <div class="logo">
                    <img src="../assets/logo.png" />
                </div>
                <nav class="nav">
                    <router-link class="nav-item" :to="{ name: 'home' }">Inicio</router-link>
                    <router-link class="nav-item" :to="{ name: 'news' }">Noticias</router-link>
                    <router-link class="nav-item" :to="{ name: 'contact' }">Contacto</router-link>
                    <router-link class="nav-item" :to="{ name: 'about' }">Acerca</router-link>
                    <router-link class="nav-item" :to="{ name: 'terms' }" target="_blank">Términos</router-link>
                </nav>
            </div>
            <div class="contact">

                <div class="social">
                    <a class="social-item" target="_blank" href="https://www.facebook.com/profile.php?id=100093142722724&locale=es_LA">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256" aria-hidden="true">
                            <g fill="#1877F2" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                font-family="none" font-weight="none" font-size="none" text-anchor="none"
                                style="mix-blend-mode: normal">
                                <path
                                    d="M51.2,256c-28.27698,0 -51.2,-22.92302 -51.2,-51.2v-153.6c0,-28.27698 22.92302,-51.2 51.2,-51.2h153.6c28.27698,0 51.2,22.92302 51.2,51.2v153.6c0,28.27698 -22.92302,51.2 -51.2,51.2z"
                                    id="shape"></path>
                            </g>
                            <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                font-family="none" font-weight="none" font-size="none" text-anchor="none"
                                style="mix-blend-mode: normal">
                                <g transform="scale(5.12,5.12)">
                                    <path
                                        d="M25,3c-12.13844,0 -22,9.86156 -22,22c0,11.01913 8.12753,20.13835 18.71289,21.72852l1.14844,0.17383v-17.33594h-5.19727v-3.51953h5.19727v-4.67383c0,-2.87808 0.69065,-4.77363 1.83398,-5.96289c1.14334,-1.18926 2.83269,-1.78906 5.18359,-1.78906c1.87981,0 2.61112,0.1139 3.30664,0.19922v2.88086h-2.44727c-1.38858,0 -2.52783,0.77473 -3.11914,1.80664c-0.59131,1.03191 -0.77539,2.264 -0.77539,3.51953v4.01758h6.12305l-0.54492,3.51953h-5.57812v17.36523l1.13477,-0.1543c10.73582,-1.45602 19.02148,-10.64855 19.02148,-21.77539c0,-12.13844 -9.86156,-22 -22,-22zM25,5c11.05756,0 20,8.94244 20,20c0,9.72979 -6.9642,17.7318 -16.15625,19.5332v-12.96875h5.29297l1.16211,-7.51953h-6.45508v-2.01758c0,-1.03747 0.18982,-1.96705 0.50977,-2.52539c0.31994,-0.55834 0.62835,-0.80078 1.38477,-0.80078h4.44727v-6.69141l-0.86719,-0.11719c-0.59979,-0.08116 -1.96916,-0.27148 -4.43945,-0.27148c-2.7031,0 -5.02334,0.73635 -6.625,2.40234c-1.60166,1.66599 -2.39258,4.14669 -2.39258,7.34961v2.67383h-5.19727v7.51953h5.19727v12.9043c-9.04433,-1.91589 -15.86133,-9.84626 -15.86133,-19.4707c0,-11.05756 8.94244,-20 20,-20z">
                                    </path>
                                </g>
                            </g>
                        </svg>
                    </a>
                    <a class="social-item" target="_blank" href="https://www.instagram.com/turismoculturalcesar/">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 256 256" aria-hidden="true">
                            <defs>
                                <linearGradient id="instaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stop-color="#F58529"/>
                                    <stop offset="30%" stop-color="#DD2A7B"/>
                                    <stop offset="60%" stop-color="#8134AF"/>
                                    <stop offset="100%" stop-color="#515BD4"/>
                                </linearGradient>
                            </defs>
                            <g fill="url(#instaGradient)" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
                                <path d="M51.2,256c-28.27698,0 -51.2,-22.92302 -51.2,-51.2v-153.6c0,-28.27698 22.92302,-51.2 51.2,-51.2h153.6c28.27698,0 51.2,22.92302 51.2,51.2v153.6c0,28.27698 -22.92302,51.2 -51.2,51.2z" id="shape"></path>
                            </g>
                            <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
                                <g transform="scale(5.12,5.12)">
                                    <path d="M16,3c-7.16752,0 -13,5.83248 -13,13v18c0,7.16752 5.83248,13 13,13h18c7.16752,0 13,-5.83248 13,-13v-18c0,-7.16752 -5.83248,-13 -13,-13zM16,5h18c6.08648,0 11,4.91352 11,11v18c0,6.08648 -4.91352,11 -11,11h-18c-6.08648,0 -11,-4.91352 -11,-11v-18c0,-6.08648 4.91352,-11 11,-11zM37,11c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2zM25,14c-6.06329,0 -11,4.93671 -11,11c0,6.06329 4.93671,11 11,11c6.06329,0 11,-4.93671 11,-11c0,-6.06329 -4.93671,-11 -11,-11zM25,16c4.98241,0 9,4.01759 9,9c0,4.98241 -4.01759,9 -9,9c-4.98241,0 -9,-4.01759 -9,-9c0,-4.98241 4.01759,-9 9,-9z"></path>
                                </g>
                            </g>
                        </svg>
                    </a>
                    <a class="social-item" target="_blank" href="https://x.com/turismoccesar">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100"
                            viewBox="0,0,256,256">
                            <g fill="#000000" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                font-family="none" font-weight="none" font-size="none" text-anchor="none"
                                style="mix-blend-mode: normal">
                                <path
                                    d="M51.2,256c-28.27698,0 -51.2,-22.92302 -51.2,-51.2v-153.6c0,-28.27698 22.92302,-51.2 51.2,-51.2h153.6c28.27698,0 51.2,22.92302 51.2,51.2v153.6c0,28.27698 -22.92302,51.2 -51.2,51.2z"
                                    id="shape"></path>
                            </g>
                            <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                font-family="none" font-weight="none" font-size="none" text-anchor="none"
                                style="mix-blend-mode: normal">
                                <g transform="scale(5.12,5.12)">
                                    <path
                                        d="M5.91992,6l14.66211,21.375l-14.35156,16.625h3.17969l12.57617,-14.57812l10,14.57813h12.01367l-15.31836,-22.33008l13.51758,-15.66992h-3.16992l-11.75391,13.61719l-9.3418,-13.61719zM9.7168,8h7.16406l23.32227,34h-7.16406z">
                                    </path>
                                </g>
                            </g>
                        </svg>
                    </a>
                    <a class="social-item" target="_blank" href="https://www.youtube.com/@TurismoCulturalCesar">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100"
                            viewBox="0,0,256,256">
                            <g fill="#FF0000" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                font-family="none" font-weight="none" font-size="none" text-anchor="none"
                                style="mix-blend-mode: normal">
                                <path
                                    d="M51.2,256c-28.27698,0 -51.2,-22.92302 -51.2,-51.2v-153.6c0,-28.27698 22.92302,-51.2 51.2,-51.2h153.6c28.27698,0 51.2,22.92302 51.2,51.2v153.6c0,28.27698 -22.92302,51.2 -51.2,51.2z"
                                    id="shape"></path>
                            </g>
                            <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                font-family="none" font-weight="none" font-size="none" text-anchor="none"
                                style="mix-blend-mode: normal">
                                <g transform="scale(5.12,5.12)">
                                    <path
                                        d="M24.40234,9c-6.60156,0 -12.80078,0.5 -16.10156,1.19922c-2.19922,0.5 -4.10156,2 -4.5,4.30078c-0.39844,2.39844 -0.80078,6 -0.80078,10.5c0,4.5 0.39844,8 0.89844,10.5c0.40234,2.19922 2.30078,3.80078 4.5,4.30078c3.50391,0.69922 9.5,1.19922 16.10156,1.19922c6.60156,0 12.59766,-0.5 16.09766,-1.19922c2.20313,-0.5 4.10156,-2 4.5,-4.30078c0.40234,-2.5 0.90234,-6.09766 1,-10.59766c0,-4.5 -0.5,-8.10156 -1,-10.60156c-0.39844,-2.19922 -2.29687,-3.80078 -4.5,-4.30078c-3.5,-0.5 -9.59766,-1 -16.19531,-1zM24.40234,11c7.19922,0 12.99609,0.59766 15.79688,1.09766c1.5,0.40234 2.69922,1.40234 2.89844,2.70313c0.60156,3.19922 1,6.60156 1,10.10156c-0.09766,4.29688 -0.59766,7.79688 -1,10.29688c-0.29687,1.89844 -2.29687,2.5 -2.89844,2.70313c-3.60156,0.69922 -9.60156,1.19531 -15.60156,1.19531c-6,0 -12.09766,-0.39844 -15.59766,-1.19531c-1.5,-0.40234 -2.69922,-1.40234 -2.89844,-2.70312c-0.80078,-2.80078 -1.10156,-6.5 -1.10156,-10.19922c0,-4.60156 0.40234,-8 0.80078,-10.09766c0.30078,-1.90234 2.39844,-2.50391 2.89844,-2.70312c3.30078,-0.69922 9.40234,-1.19922 15.70313,-1.19922zM19,17v16l14,-8zM21,20.40234l8,4.59766l-8,4.59766z">
                                    </path>
                                </g>
                            </g>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import Splide from '@splidejs/splide';

export default {
    name: "edc-footer",
    mounted() {
        new Splide('#footer-splide', {
            type: "loop",
            autoplay: true,
            autoWidth: true,
            perMove: 2,
            snap: true,
            speed: 750,
            gap: '32px',
            pauseOnHover: false,
            pagination: false,
            arrows: false,
            padding: '24px'
        }).mount()
    }
}
</script>

<style scoped>
.edc-footer__splide {
    margin: 16px 0px;
}

.edc-footer__splide img {
    height: 60px;
}

.edc-footer {
    width: 100%;
    background-color: var(--color-dark);
}

.content {
    width: 100%;
    max-width: 1000px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 40px 24px;
    gap: 40px;
}

.navegation {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

.navegation .logo {
    width: 140px;
    height: 140px;
}

.navegation .logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: brightness(99);
}

.navegation .nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.navegation .nav .nav-item {
    color: var(--color-light);
    font-weight: normal;
    text-decoration: none;
}

.contact {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.contact .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.contact .info a {
    color: var(--color-light);
    font-size: 16px;
    font-weight: bold;
    text-decoration: none;
}

.contact .social {
    display: flex;
    gap: 8px;
}

.contact .social .social-item {
    width: 45px;
    height: 45px;
}

.contact .social .social-item svg {
    width: 100%;
    height: 100%;
}

.subfooter {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    padding: 6px 0px;
    background-color:rgb(47, 47, 47);
    color: white;
}

.subfooter img {
    height: 32px;
    filter: brightness(99);
}

@media (min-width: 920px) {
    .content {
        flex-direction: row;
        justify-content: space-between;
        padding: 24px;
    }

    .navegation {
        flex-direction: row
    }

    .navegation .nav {
        flex-direction: row
    }

    .contact {
        justify-content: center
    }

    .contact .info {
        align-items: end
    }
}
</style>